(() => {
  const textBlocks = document.querySelectorAll(".text");

  if (!textBlocks.length) return;

  textBlocks.forEach((textBlock) => {
    const isSmall = textBlock.classList.contains("is-small");
    const externalLinks = textBlock.querySelectorAll(
      ".text a[target=_blank]:not([class])"
    );

    if (!externalLinks.length) return;

    // add extra span inside external links
    // for better external icon rendering
    // <a href="link is-dark">
    //   <span class="link__text">{text}</span>
    // </a>
    externalLinks.forEach((link) => {
      link.classList.add("link", "is-dark");

      const isBold =
        link.parentNode?.nodeName === "STRONG" ||
        link.firstChild?.nodeName === "STRONG";

      if (isBold) {
        link.classList.add("is-bold");
      }

      if (isSmall) {
        link.classList.add("is-small");
        link.classList.remove("is-dark");
      }

      // create .link__text span
      const textOuterWrapper = document.createElement("span");
      textOuterWrapper.classList.add("link__inner");

      const textInnerWrapper = document.createElement("span");
      textInnerWrapper.classList.add("link__text");

      // add span inside link
      textInnerWrapper.innerHTML = link.innerHTML;
      link.innerHTML = "";
      textOuterWrapper.appendChild(textInnerWrapper);
      link.appendChild(textOuterWrapper);
    });
  });
})();

export {};
